<template>
  <div class="py-4 px-6">
    <nuxt-link to="/" class="nav mb-3 page-padding-x flex items-center gap-2">
      <img
        src="/assets/BiArrowLeftCircle.svg"
        class="w-5 h-5"
        alt="arrow pointing left"
      />
      projects
    </nuxt-link>
    <NuxtLayout name="header">
      <NuxtPage></NuxtPage>
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
